import { render, staticRenderFns } from "./ProjectsAddedChart.vue?vue&type=template&id=dc225efa&scoped=true&"
import script from "./ProjectsAddedChart.vue?vue&type=script&lang=js&"
export * from "./ProjectsAddedChart.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsAddedChart.vue?vue&type=style&index=0&id=dc225efa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc225efa",
  null
  
)

export default component.exports